module.exports = __webpack_public_path__ + "img/chat-left-dots.cf486305.svg";